// API base URL resolution, in priority order:
//   1. Runtime config (public/config.js → window.__NEXINV_CONFIG__.apiUrl) — set
//      per client on the server, no rebuild needed.
//   2. Build-time env (VUE_APP_API_URL) — baked in at `npm run build`.
//   3. Local dev fallback.
const runtime = (typeof window !== 'undefined' && window.__NEXINV_CONFIG__) || {};

const endpoint =
  (runtime.apiUrl && String(runtime.apiUrl).trim()) ||
  process.env.VUE_APP_API_URL ||
  'http://127.0.0.1:8003/api'

export default endpoint
